<input type="radio"
     class="hidden-radio"
       [formControl]="control"
       [id]="controlId"
      [value]="value"
      [name]="name">
  <label [for]="controlId" class="custom-radio-label font-weight-normal-bold bg-label-wizard border-gray-wizard text-color-wizard  font-size-14
  px-3 py-2 display-flex align-items-center justify-content-center cursor-pointer bg-label-wizard">
    <span class="translate-left-7"><ng-content></ng-content></span>
    <img src="/assets/images/checkmark2.svg" class="checkmark-icon checkmark-button-width ml-1" alt="">
  </label>
